module.exports = __webpack_public_path__ + "static/media/bonariv-header.903a2c0e.jpg";